export default __webpack_public_path__ + "static/media/PAYROLL-assignment-set.0f984df5.PNG";